import { z } from 'zod';
import { AcademicRecordId, StudentId, AcademicYear } from '../types/branded';
import { GradeLevel, SchoolDivision } from '../types/enums';

export const AcademicRecordSchema = z.object({
  id: AcademicRecordId,
  studentId: StudentId,
  academicYear: AcademicYear,
  grade: GradeLevel,
  division: SchoolDivision,
  programNotes: z.string().nullable().optional(),
  accommodations: z.array(z.string()).default([]),
  createdAt: z.string(),
});
export type AcademicRecord = z.infer<typeof AcademicRecordSchema>;
